import { Flex } from '@chakra-ui/react';

import { TagColored } from 'uiToolkitV1/Tag';
import { TextBodyMedium, TextHeader4 } from 'uiToolkitV1/Typography';

import { ViolationTimeline } from '../../CreateViolationDrawer/components/ViolationTimeline';
import { VIOLATION_STATUS } from '../types';

type ViewViolationHeaderProps = {
  violationStatus: keyof typeof VIOLATION_STATUS;
  isEmployeeView: boolean;
};

export const ViewViolationHeader = ({ violationStatus, isEmployeeView }: ViewViolationHeaderProps) => {
  // EMPLOYEE VIEW
  if (isEmployeeView) {
    const isAcknowledged = violationStatus === VIOLATION_STATUS.ACKNOWLEDGED;
    const label = isAcknowledged ? 'Acknowledged' : 'Pending acknowledgement';
    const color = isAcknowledged ? 'green' : 'darkYellow';

    return (
      <Flex h="40px" alignItems="center" justifyContent="center" gap="8px" borderBottom="1px solid #E7E7E7">
        <TextBodyMedium flex="1" bold>
          View disciplinary action
        </TextBodyMedium>
        <TagColored color={color}>{label}</TagColored>
      </Flex>
    );
  }

  // MANAGER AND ADMIN VIEW
  return (
    <Flex flexDir="column" justifyContent="center" minH="112px" w="full" borderBottom="1px solid #E7E7E7" gap="6px">
      <TextHeader4 bold>View disciplinary actions</TextHeader4>
      <ViolationTimeline status={violationStatus} />
    </Flex>
  );
};
